<template>
  <section
    v-if="advantages.length"
    class="lpu-advantages d-flex flex-column"
    :class="isMobile ? 'ga-6' : 'ga-8'"
    data-qa="lpu_advantages"
  >
    <h2
      data-qa="lpu_advantages_title"
      class="text--text"
      :class="isMobile ? 'text-h6' : 'text-h5'"
    >
      {{ tStatic('Преимущества') }}
    </h2>

    <template v-if="isMobile">
      <AdvantageVideo
        v-if="videoUrl && videoUuid"
        :video-url="videoUrl"
        :video-uuid="videoUuid"
        :preview-url="previewUrl"
      />
      <div class="d-flex flex-column ga-6">
        <AdvantageItem
          v-for="(item, index) in advantages"
          :key="`${item.icon.slug}-${index}`"
          :advantage="item"
        />
      </div>
    </template>

    <div
      v-else-if="videoUrl && videoUuid"
      class="lpu-advantages__layout lpu-advantages__layout--with-video"
    >
      <AdvantageItem
        v-for="(item, index) in advantages"
        :key="`${item.icon.slug}-${index}`"
        class="lpu-advantages__item"
        :class="index % 2 === 0
          ? 'lpu-advantages__item--left'
          : 'lpu-advantages__item--right'"
        :style="{ gridRow: Math.floor(index / 2) + 1 }"
        :advantage="item"
      />
      <AdvantageVideo
        class="lpu-advantages__video"
        :class="{ 'lpu-advantages__video--desktop': !isMobile }"
        :video-url="videoUrl"
        :video-uuid="videoUuid"
        :preview-url="previewUrl"
      />
    </div>

    <div
      v-else
      class="lpu-advantages__list--desktop"
    >
      <AdvantageItem
        v-for="(item, index) in advantages"
        :key="`${item.icon.slug}-${index}`"
        :advantage="item"
      />
    </div>
  </section>
</template>

<script setup lang="ts">
import useIsMobile from 'src/composables/useIsMobile'
import tStatic from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_functions/tStatic'
import type { LpuBrandingAdvantage } from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_types'
import AdvantageItem from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuAdvantages/components/AdvantageItem.vue'
import AdvantageVideo from 'src/components/pages/[town-translit]/lpu/[lpu-translit]/_components/LpuAdvantages/components/AdvantageVideo.vue'

defineProps<{
  advantages: LpuBrandingAdvantage[]
  videoUrl?: string
  videoUuid?: string
  previewUrl?: string
}>()

const isMobile = useIsMobile()
</script>

<style scoped lang="scss">
.lpu-advantages {
  &__layout--with-video {
    display: grid;
    grid-template-columns: minmax(0, 1fr) auto minmax(0, 1fr);
    gap: 60px 32px;
    align-items: start;
  }

  &__video {
    grid-column: 2;
    place-self: start;

    &--desktop {
      margin: -67px -24px 0;
      grid-row: 1 / span 3;
    }
  }

  &__item--left {
    grid-column: 1;
  }

  &__item--right {
    grid-column: 3;
  }

  &__list--desktop {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 60px 16px;
  }
}
</style>
